<script>
    import Sidebar from './Sidebar.svelte'
    let hamburger = 'images/hamburger.svg';
    let xmologo = 'images/houseMiddle.png';
    import { _ } from '../../services/i18n';
 
    import { fly } from 'svelte/transition';
    export let open = false
    let y;


</script>

<svelte:window bind:scrollY={y}/>
<nav class="smallscreen">
        <div class="topnavwrapper">
            <div class="rapper">
            <a href="#homepage" >
                <img src={xmologo} alt="xmo logo"  class="logo">
            </a>
             <a href={'#!'}  on:click={() => open = !open} > 
                <img src={hamburger} alt="hamburger menu" class="hamburger">
            </a>
            </div>
            <div class="navwrapper">
                <Sidebar bind:open/>
            </div>
        </div>
</nav>




<nav class="bigscreen">
    <div class="topnav">
     
            <div class="logowrapper">
                <a href="#homepage">
                    <img src={xmologo} alt="xmo logo"  class="logo">
                </a>
                {#if y < 500}
                <div class="titlewrapper" transition:fly={{ y:-100, duration: 200, opacity: 1 }}>
                    <h1 class="titleh1">EKMON</h1>
                    
                </div>
                {/if}
            </div>
            <div class="myLinks">
                <a href="#about">{$_('about')}</a>
                <a href="#projects">{$_('projects')}</a>
                <a href="#contact">{$_('contact')}</a>
            </div>
        
    </div>
</nav>

<style>

.bigscreen {
    display: none;
}
nav {

    height: 40%;
    width: 100%;
}

.topnav {
    display: flex;
    justify-content: space-between;
    position: fixed;
}
.topnavwrapper {
    top:3%;
    left: 5%;
    width: 90%;
    display: block;
    justify-content: space-between;
    position: fixed;
}
.rapper {
    margin: 0 auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.navwrapper {
    width: 100%;
    display: block;
    justify-content: space-between;
    
}
.myLinks {
    display: flex;
    height: 20%;
    width: 100%;
    margin-top: 16%;
    flex-direction: column;
    justify-content: space-between;
    /* position: fixed; */
   
}
.myLinks a {
    font-size: 28px;
    color: #474444;
    font-family: Helvetica, sans-serif;
    font-weight: 800;
}
.hamburger {
    width: 2.8em;
    padding-top: 0.4em;
    
    
}
.logo{
    margin-top: 6px;
    width: 70px;
}


/* Add a grey background color on mouse-over */
.topnav a:hover {
  /* background-color: #ddd; */
  color: black;
}



@media (min-width: 1366px) {
    .smallscreen {
        display: none;
    }
    .bigscreen {    
    display: flex;
    margin: 0 auto;
    width: 1366px;          
    }
    nav {
    height: 12%;
    }
    .topnav {
    width: 1366px;  
    display: flex;

    }
    .topnavwrapper {
    width: 1366px;
    display: flex;
    justify-content: space-between;
    position: fixed;
    text-align: center;
    }

    .myLinks {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    width: 600px;
    margin-top: 70px;
    height: 30%;
    position:unset;

    }
    .logo{
    display: flex;

    margin-top: 64px;
    }
    .logowrapper {
        display: flex;
        height: 100%;
    }
    .titlewrapper {
        margin-top: 78px;
        margin-left: 14px;;
    }
    .titleh1{
        font-size: 48x;
    	font-family: Helvetica, sans-serif;
    	font-weight: 800;
        margin-top: 0%;
        margin-bottom: 0%;
        letter-spacing: 1.2px;
        color: #474444;

    }
    .titleh2{
        font-size: 16px;
        font-family: 'Oswald';
        font-weight: bold;
        margin-top: -8px;
        margin-bottom: 0%;
        letter-spacing: 1px;
        word-spacing: 6px;
        color: #474444;   
    }
}

</style>